import React from 'react'
import {connect} from "react-redux";
import workspace from "../canvas/core/workspace";
import {changeValuePopupInterface} from "../../interfaces/sqftInterfaces";
import useLongPress from "../../hocs/useLongPress";

const ChangeValuePopupWindow = (props) => {
  const {id, min, max, confirmCallback, increaseCallback, decreaseCallback, inputChangeCallback, value, position} = props;

  const onIncreaseLongPress = () => {
    console.log('long press is triggered');
    increaseCallback(id);
  };

  const onIncreaseClick = (id) => {
    increaseCallback(id);
  }

  const onDecreaseLongPress = () => {
    console.log('long press is triggered');
    decreaseCallback(id);
  };

  const onDecreaseClick = (id) => {
    decreaseCallback(id);
  }

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };

  const increaseLongPressEvent = useLongPress(onIncreaseLongPress, onIncreaseClick, defaultOptions);
  const decreaseLongPressEvent = useLongPress(onDecreaseLongPress, onDecreaseClick, defaultOptions);

  return (
    <div className={"change-value-popup tooltip tooltip-angle change-value-popup-" + (id)}
         style={{ left: position.left + 'px', top: position.top + 'px'}}>
      <div className="tooltip-angle-nav">
        <input type="number" className="ui-input tooltip-angle-nav-input" min={min} max={max} value={value} onChange={(id) => inputChangeCallback(id)}/>
        <div className="tooltip-angle-nav-arrow tooltip-angle-nav-arrow-up" {...increaseLongPressEvent} >
          <svg className="triangle">
            <path d="M 22 8 L 40 30 L 5 30 z" stroke="#ffffff" strokeLinejoin="round" strokeWidth="8px"/>
            <path d="M 22 13 L 35 30 L 9 30 z" fill="#4A90E2" stroke="#4A90E2" strokeLinejoin="round" strokeWidth="8px"/>
          </svg>
        </div>
        <div className="tooltip-angle-nav-arrow tooltip-angle-nav-arrow-down" {...decreaseLongPressEvent}>
          <svg className="triangle">
            <path d="M 22 8 L 40 30 L 5 30 z" stroke="#ffffff" strokeLinejoin="round" strokeWidth="8px"/>
            <path d="M 22 13 L 35 30 L 9 30 z" fill="#4A90E2" stroke="#4A90E2" strokeLinejoin="round" strokeWidth="8px"/>
          </svg>
        </div>
      </div>
      <button className="ui-button10 ui-button10--green tooltip-angle-btn"
              onClick={() => confirmCallback()}>
        {workspace.intl.formatMessage({id: "sqft.contextmenu.angleTooltipClose"})}
      </button>
    </div>
  )
};

ChangeValuePopupWindow.propTypes = changeValuePopupInterface;

const mapStateToProps = (store) => ({
  activeButton: store.sqftMenuState.activeButton,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeValuePopupWindow);
